module.exports = __webpack_public_path__ + "img/ic-purchase-orders.e982fd90.svg";